import Vue from 'vue';
import store from '@/store';
import router from '@/router';
import { components as sccComponents } from '@lotify/sales-channel-components';
import { components as knvbComponents } from '@/plugins/knvb-components';
import { components as kwfComponents } from '@/plugins/kwf-components';

if (process.env.VUE_APP_EDITOR) {
    import('@lotify/sales-channel-editor').then(salesChannelEditor => {
        const editor = salesChannelEditor.createEditor({
            store,
            router,
            token: process.env.VUE_APP_TOKEN,
            apiUrl: process.env.VUE_APP_SALES_CHANNEL_URL,
            components: [...Object.keys(sccComponents), ...Object.keys(knvbComponents), ...Object.keys(kwfComponents)],
        });

        Vue.use(editor);
    });
}
